import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { client } from 'utils/api-client';

interface UpdateCheckoutSessionMetadataRequest {
  session_id: string;
  set_as_default: boolean;
  /** Omitted by callers that never offer the toggle, which leaves the session's value alone. */
  enable_auto_pay?: boolean;
}

function useUpdateCheckoutSessionMetadata(): UseMutationResult<
  AxiosResponse<void>,
  AxiosError,
  UpdateCheckoutSessionMetadataRequest
> {
  // PUT: the staff endpoint answers PATCH with a 405, and this call has no error handler, so the
  // mismatch showed up as the session quietly keeping the metadata it was created with.
  return useMutation((data: UpdateCheckoutSessionMetadataRequest) =>
    client.put('/payment-methods/checkout-session-metadata/', data),
  );
}

export default useUpdateCheckoutSessionMetadata;
